import { useState, useEffect } from "react";

/**
 * Debounces a value so API calls / filters do not run on every keystroke.
 * @param {any} value
 * @param {number} delayMs
 */
export function useDebouncedValue(value, delayMs = 400) {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(t);
  }, [value, delayMs]);

  return debounced;
}
